import { api } from './http';
import type { Me } from './types';

export const auth = {
  me: (signal?: AbortSignal) => api.get<Me>('/auth/me', signal),
  /** Ends this session server-side and clears both cookies. */
  logout: () => api.post<{ ok: true }>('/auth/logout', {}),
};
